import { render } from "./SchoolDetailSetting.vue?vue&type=template&id=7197c320&ts=true"
import script from "./SchoolDetailSetting.vue?vue&type=script&lang=ts"
export * from "./SchoolDetailSetting.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__